// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","headers":"Table_headers__ZGTvU","sortable":"Table_sortable__StU+8","sorted":"Table_sorted__vJGFX","reversed":"Table_reversed__igPFw"};